import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  series: z.tuple([z.string(), z.number()], { message: msg.required }),
  name: z.string().min(1, { message: msg.required }),
  results_per_round: z.coerce.number().min(1, { message: msg.required }),
  max_teams: z.coerce.number().min(1, { message: msg.required }),
  level: z.coerce.number().min(1, { message: msg.required }),
  rounds: z.array(z.number()).min(1, { message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
